import leftArrow from '../../../../../images/leftArrow.png'
import home from '../../../../../images/home.png'
import rightArrow from '../../../../../images/rightArrow.png'

import positiveImpactIcon from '../../../../../images/positiveImpactIcon.png';
import positiveImpactDetailTitle from '../../../../../images/positiveImpactDetailTitle.png';

import negativeImpactIcon from '../../../../../images/negativeImpactIcon.png';
import negativeImpactDetailTitle from '../../../../../images/negativeImpactDetailTitle.png';

import advantageIcon from '../../../../../images/advantageIcon.png';
import advantageDetailTitle from '../../../../../images/advantageDetailTitle.png';

import concernIcon from '../../../../../images/concernIcon.png';
import concernDetailTitle from '../../../../../images/concernDetailTitle.png';

import compatibilityIcon from '../../../../../images/compatibilityIcon.png';



export const POSITIVE_IMPACT = [
    {
        link:'',
        header_background_image: positiveImpactDetailTitle,
        header_text:'POSITIVE IMPACT',
        header_sub_text: '(Individual is better than team)',
        child_content: [
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Concern :',
                child_content:"Being sensitive to others' feelings when sharing their opinions",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sl :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time seme :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time selo :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time soko :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            }
            
        ]
    }
]

export const NEGATIVE_IMPACT = [
    {
        link:'',
        header_background_image: negativeImpactDetailTitle,
        header_text:'NEGATIVE IMPACT',
        header_sub_text: '(Team is better than individual)',
        child_content: [
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Concern :',
                child_content:"Being sensitive to others' feelings when sharing their opinions",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            }
        ]
    }
]

export const ADVANTAGE = [
    {
        link:'',
        header_background_image: advantageDetailTitle,
        header_text:'ADVANTAGE',
        header_sub_text: '(Common Strength and Tactics)',
        child_content: [
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Concern :',
                child_content:"Being sensitive to others' feelings when sharing their opinions",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense:',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense:',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense:',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense:',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense:',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            }
        ]
    }
]

export const CONCERN = [
    {
        link:'',
        header_background_image: concernDetailTitle,
        header_text:'CONCERN',
        header_sub_text: '(Common Weakness/ Threats)',
        child_content: [
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Concern :',
                child_content:"Being sensitive to others' feelings when sharing their opinions",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            },
            {
                child_content_background_color: 'linear-gradient(to right, #d3ef77 , #afef9a)',
                child_header: 'Time sense :',
                child_content: "Timing their decisions well and striking at the right time",
                child_footer: '',
                link:``,
            }
        ]
    }  

]

export const classNameCustom = {
    main_container: 'd-flex flex-row flex-wrap align-items-start col-12',
    container: {
        container: "d-flex flex-column col-sm-12 col-md-12 col-lg-12 w-100 p-1",
        style: {
            margin: 1,
        }
    },
    header_container: {
        header_container: 'w-100 py-1 my-1',
        style:{
            paddingLeft:80,
            margin:1
        }
    },
    header_container_non_routable: {
        header_container_non_routable: 'd-flex flex-row align-items-center justify-content-start text-white py-3',
        header_container_non_routable_title: 'font-weight-bold',
        header_container_non_routable_optional:'pl-3 font-italic detailed-compatibility-child',
    },
    child_container: {
        child_container: "d-flex flex-column col-12 flex-wrap w-100 px-0",
        style: {
            margin:1,
        }
    },
    child_content_container: {
        child_content_container: 'd-flex col-sm-12 col-md-12 col-lg-12 px-3 py-2 my-1 text-dark text-center',
        child_content_container_header: 'font-weight-bold detailed-compatibility-child-header',
        child_content_container_desc: 'detailed-compatibility-child-desc pl-3 py-1',
        child_content_container_footer: '',
    }
}


export const arrow_button_data = [
    {
        img: leftArrow,
        name: "Prev",
        id: 1,
        tooltip_id:1
    },{
        img: home,
        name: "Home",
        id: 2,
        tooltip_id:2
    },{
        img: rightArrow,
        name: "Next",
        id: 3,
        tooltip_id:3
    },
]

export const single_button_data = [
    {
        img: compatibilityIcon,
        name: "Compatibility",
        id: 111,
        tooltip_id:111
    }
]

export const button_data = [
    {
        img: compatibilityIcon,
        name: "Compatibility",
        id: null,
        tooltip_id:0
    },
    {
        img: positiveImpactIcon,
        id:"POSITIVE IMPACT",
        name: "Positive",
        tooltip_id:1
    },
    {
        img: negativeImpactIcon,
        id:"NEGATIVE IMPACT",
        name: "Negetive",
        tooltip_id:2
    },
    {
        img: advantageIcon,
        id:"ADVANTAGE",
        name: "Advantage",
        tooltip_id:3
    },
    {
        img: concernIcon,
        id:"DISADVANTAGE",
        name: "DISADVANTAGE",
        tooltip_id:4
    },
]


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/Compatibility/CompatibilityExtensionData.js